import React from "react";
import styled from "styled-components";
import { FontWeight, Spacing, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

interface IProps {
  totalPosts: number;
  locale: Locale;
  showPagination: boolean;
  page: { from: number; to: number };
  onClickView: () => void;
  onPageUp: () => void;
  onPageDown: () => void;
}

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.Large};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => content(props, "secondary")};
  font-weight: ${FontWeight.Normal};
`;

const Counter = styled.div`
  margin-left: ${Spacing.Medium};
`;

const TopPostsFooter = ({
  totalPosts,
  locale,
  onClickView,
  onPageUp,
  onPageDown,
  showPagination,
  page,
}: IProps) => {
  return (
    <Footer>
      {showPagination && (
        <Pagination>
          <Button
            onClick={onPageUp}
            icon="chevron-small-down"
            isDisabled={page.to >= totalPosts}
            variant="tertiary"
            size="s"
          />
          <Button
            onClick={onPageDown}
            icon="chevron-small-up"
            isDisabled={page.from === 1}
            variant="tertiary"
            size="s"
          />
          <Counter>
            {page.from} - {page.to}
          </Counter>
        </Pagination>
      )}
      <Button
        variant="tertiary"
        text={tr(locale, "CUSTOM_PAGES::WIDGET::TOP_POSTS::VIEW_ALL")}
        onClick={onClickView}
        isDisabled={!onClickView}
      />
    </Footer>
  );
};

export default TopPostsFooter;
